import styled from "styled-components"

const ResultSuccessTickMarkContainer = styled.div`


    .checkmark {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        stroke-width: 5;
        stroke: #fff;
        stroke-miterlimit: 10;
        box-shadow: inset 0px 0px 0px var(--color-main);
        animation: fill 0.4s ease-in-out 0.4s forwards,
        scale 0.3s ease-in-out 0.9s both;
    }

    .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 12;
    stroke-miterlimit: 10;
    stroke: var(--color-main);
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }

    .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
    }

    @keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
    }
    @keyframes scale {
    0%,
    100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.2, 1);
    }
    }
    @keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px ${({color})=> color};

    }
    }

`

const ResultSuccessTickMark = () => {
    return (
        <ResultSuccessTickMarkContainer color={"#E85446"}>
            <svg
            className="checkmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
            >
            <circle className="checkmark__circle" cx="26" cy="26" r="6.1" fill="#E85446" />
            <path
                className="checkmark__check"
                fill="#E85446"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
            </svg>
        </ResultSuccessTickMarkContainer>
    )
}
  
  export default ResultSuccessTickMark
  